import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=1d1f6400&scoped=true&"
import script from "./FooterLinks.vue?vue&type=script&lang=js&"
export * from "./FooterLinks.vue?vue&type=script&lang=js&"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=1d1f6400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f6400",
  null
  
)

/* custom blocks */
import block0 from "@/locales/footer_links.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fjenkins%2Fworkspace%2Fon-production-deploy%2Ffront%2Fcomponents%2FFooter%2FFooterLinks.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports